import { createContext, useContext, useState } from "react";

const ToastContext = createContext();
export const useToast = () => useContext(ToastContext);

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  const addToast = (message, type = "success") => {
    const id = Date.now();
    setToasts((prev) => [...prev, { id, message, type }]);

    setTimeout(() => {
      setToasts((prev) => prev.filter((toast) => toast.id !== id));
    }, 4000);
  };

  return (
    <ToastContext.Provider value={{ addToast }}>
      {children}

      {/* Toast Container */}
      <div className="fixed top-6 left-1/2 -translate-x-1/2 z-50 space-y-3 px-4 w-full flex flex-col items-center">
        {toasts.map(({ id, message, type }) => (
          <div
            key={id}
            className={`flex items-center gap-2 px-4 py-2 rounded-lg shadow-md border text-sm font-medium max-w-fit animate-fade-in
              ${
                type === "success"
                  ? "bg-green-50 border-green-300 text-green-800"
                  : type === "warning"
                  ? "bg-yellow-50 border-yellow-300 text-yellow-800"
                  : "bg-red-50 border-red-300 text-red-800"
              }
            `}
          >
            {type === "success" ? (
              <svg
                className="w-4 h-4 text-green-600 shrink-0 animate-draw-check"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
              </svg>
            ) : type === "warning" ? (
              <svg
                className="w-4 h-4 text-yellow-600 shrink-0 animate-pulse"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01M12 5a7 7 0 100 14 7 7 0 000-14z" />
              </svg>
            ) : (
              <svg
                className="w-4 h-4 text-red-600 shrink-0 animate-draw-circle-x"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                viewBox="0 0 24 24"
              >
                <circle cx="12" cy="12" r="9" />
                <path strokeLinecap="round" strokeLinejoin="round" d="M15 9l-6 6M9 9l6 6" />
              </svg>
            )}

            <span className="text-sm font-medium leading-tight">{message}</span>
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
};
